'use client'
// =============================================================================
// WorkStartCard — accueil connecté : « par où commencer », d'après la même liste
// que l'accueil public et la fenêtre de bienvenue (lib/presentation/modules.ts).
// Seuls les modules qui ont une page apparaissent ; chacun garde son état réel.
// =============================================================================

import Link from 'next/link'

import { MODULES, STATE_LABEL, GROUP_LABEL, PRINCIPLE, type ModuleGroup } from '@/lib/presentation/modules'
import { SectionLabel } from './SectionLabel'

export function WorkStartCard() {
  const groups: ModuleGroup[] = ['travail', 'agents', 'intelligence']
  return (
    <section style={{ marginBottom: 28 }}>
      <SectionLabel>Votre environnement de travail</SectionLabel>
      <div className="hud-card" style={{ padding: '16px 18px' }}>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 14 }}>
          <span style={{ fontSize: 13, color: 'var(--white)', fontWeight: 600 }}>{PRINCIPLE.join(' ')}</span>
          <Link href="/bureau/affaires?tab=projects" style={{
            marginLeft: 'auto', fontSize: 11, fontFamily: 'var(--font-mono)', fontWeight: 700, color: '#020408',
            background: 'var(--accent)', padding: '6px 12px', borderRadius: 6, textDecoration: 'none',
          }}>+ Nouveau projet</Link>
        </div>
        {groups.map(g => {
          const mods = MODULES.filter(m => m.group === g && m.href)
          if (!mods.length) return null
          return (
            <div key={g} style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 9, fontFamily: 'var(--font-mono)', letterSpacing: '0.15em', color: 'var(--text-muted)', marginBottom: 6 }}>
                {GROUP_LABEL[g].toUpperCase()}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 220px), 1fr))', gap: 8 }}>
                {mods.map(m => (
                  <Link key={m.key} href={m.href!} style={{
                    display: 'flex', flexDirection: 'column', gap: 4, padding: '10px 12px', borderRadius: 8, textDecoration: 'none',
                    border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.02)', minWidth: 0,
                  }}>
                    <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <span style={{ color: 'var(--accent)' }}>{m.icon}</span>
                      <strong style={{ color: 'var(--white)', fontSize: 13 }}>{m.name}</strong>
                      {m.state !== 'service' && (
                        <span style={{ marginLeft: 'auto', fontSize: 9, fontFamily: 'var(--font-mono)', color: STATE_LABEL[m.state].color }}>
                          {STATE_LABEL[m.state].label}
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.45 }}>{m.pitch}</span>
                  </Link>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
